
import { useState, useEffect } from 'react';
import { PaymentType } from '@/types/payment';
import { PaymentFilters } from './types';

export const usePaymentFilters = (payments: PaymentType[]) => {
  const [filteredPayments, setFilteredPayments] = useState<PaymentType[]>([]);
  const [filters, setFilters] = useState<PaymentFilters>({
    searchQuery: '',
    paymentMethod: 'all',
    dateRange: undefined,
    activeTab: 'all'
  });

  useEffect(() => {
    let filtered = [...payments];
    
    // Filter by status (tab)
    if (filters.activeTab !== 'all') {
      filtered = filtered.filter(payment => payment.status === filters.activeTab);
    }
    
    // Filter by search query
    if (filters.searchQuery) {
      const query = filters.searchQuery.toLowerCase();
      filtered = filtered.filter(
        payment => 
          payment.referrerName.toLowerCase().includes(query) ||
          payment.referrerId.toLowerCase().includes(query) ||
          payment.email?.toLowerCase().includes(query)
      );
    }
    
    // Filter by payment method
    if (filters.paymentMethod !== 'all') {
      filtered = filtered.filter(payment => payment.method === filters.paymentMethod);
    }
    
    // Filter by date range
    if (filters.dateRange?.from && filters.dateRange?.to) {
      filtered = filtered.filter(payment => {
        const paymentDate = new Date(payment.date);
        const from = filters.dateRange?.from as Date;
        const to = filters.dateRange?.to as Date;
        return paymentDate >= from && paymentDate <= to;
      });
    }
    
    setFilteredPayments(filtered);
  }, [payments, filters]);

  return {
    filteredPayments,
    filters,
    setFilters
  };
};
